<template>
  <div>
    <my-header
      :page_name="$t('navigation.headerTitles.configTasks')"
      show_usermenu
    ></my-header>
    <div v-if="formOpen">
      <my-form
        v-if="formActionType !== ''"
        :formActionType="formActionType"
        type="task"
        @close="formOpen = false"
        @editOk="editOk"
        @addOk="addOk"
      ></my-form>
    </div>
    <el-dialog
      :visible.sync="formParamsOpen"
      v-if="formParamsOpen"
      center
      :title="title"
      width="90%"
    >
      <config-task-form
        @onClose="closeDialog"
        @addOk="updParams"
      ></config-task-form>
    </el-dialog>

    <div class="buttons-grid between">
      <!-- <el-button class="el-icon-">Скачать</el-button> -->
      <div>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('configTasks.add')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="createClick"
              class="el-icon-plus"
              type="primary"
            ></el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('configTasks.editTask')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="editTaskClick"
              class="el-icon-edit"
              type="primary"
              :disabled="buttonDisabled"
            ></el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('configTasks.editParams')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="editParamsClick"
              class="el-icon-edit-outline"
              :disabled="buttonDisabled"
              type="primary"
            ></el-button>
          </span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('configTasks.delete')"
          placement="bottom-start"
        >
          <span>
            <el-button
              @click="deleteClick"
              type="danger"
              class="el-icon-delete"
              :disabled="buttonDisabled"
            ></el-button>
          </span>
        </el-tooltip>
      </div>
      <div v-if="getUser && +getUser.roleid <= 1">
        <el-dropdown trigger="click">
          <el-button type="plain" size="small">
            {{ $t("configTasks.export") }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('configTasks.insertTooltip')"
              placement="right"
            >
              <el-dropdown-item
                @click.native="exportTask('insert')"
                :disabled="exportDisabled"
                >{{ $t("configTasks.insert") }}</el-dropdown-item
              >
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('configTasks.deleteTooltip')"
              placement="right"
            >
              <el-dropdown-item
                @click.native="exportTask('delete')"
                :disabled="exportDisabled"
                >{{ $t("configTasks.delete") }}</el-dropdown-item
              >
            </el-tooltip>
          </el-dropdown-menu>
        </el-dropdown>
        <el-tooltip
          class="item"
          effect="light"
          :content="$t('navigation.userMenu.backup')"
          placement="bottom-start"
        >
          <span>
            <el-button @click="backupBase" class="el-icon-upload left">{{
              $t("navigation.userMenu.backup")
            }}</el-button>
          </span>
        </el-tooltip>
      </div>
      <el-dropdown trigger="click">
        <el-button type="plain" size="small">
          {{ $t("configTasks.view") }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="optimalViewBtn">{{
            $t("configTasks.compact")
          }}</el-dropdown-item>
          <el-dropdown-item @click.native="fullViewBtn">{{
            $t("configTasks.full")
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-row v-if="!gridLoading">
      <el-col :span="24" class="grid-container-full">
        <ag-grid-vue
          style="
            width: 100%;
            height: 100%;
            font-family: 'Open Sans', sans-serif;
          "
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :rowData="getTasksTable"
          :defaultColDef="defaultColDef"
          rowSelection="multiple"
          suppressCellSelection
          :localeText="agGridlocaleText"
          @grid-ready="onGridReady"
          @first-data-rendered="onGridFirstDataRendered"
          @gridSizeChanged="onGridSizeChanged"
          @rowSelected="onRowSelected"
          @row-data-changed="onGridDataChanged"
        ></ag-grid-vue>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ConfigTaskForm from "../../components/config/ConfigTaskForm";
import Form from "../../components/config/form_elements/Form";
import Header from "../../components/reusable/header/Header";
import { AgGridVue } from "ag-grid-vue";
import { mapGetters } from "vuex";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
export default {
  data() {
    return {
      buttonDisabled: true,
      exportDisabled: true,
      formOpen: false,
      formParamsOpen: false,
      action: "",
      title: "",
      loading: true,
      gridLoading: true,
      columnDefs: null,
      agGridlocaleText: null,
      defaultColDef: null,
      gridApi: null,
      columnApi: null,
      settings: null,
      currentRowSelected: null,
      selectedArray: [],
      currentId: null,
      formActionType: "",
      //данные отрендерились в первый раз (для того, чтобы потом выключать loading при обновлении)
      firstRenderFlag: false,
    };
  },
  methods: {
    // this.gridApi.refreshCells(); // обновление данных
    createClick() {
      this.title = this.$t("configTasks.addTask");
      this.action = "create";
      this.formActionType = "add";
      this.formOpen = true;
    },
    editTaskClick() {
      this.formActionType = "edit";
      this.$store.commit("setCurInfo", this.currentRowSelected);
      this.formOpen = true;
    },
    editParamsClick() {
      this.title =
        this.$t("configTasks.editParams") +
        ": " +
        this.currentRowSelected.caption;
      this.$store
        .dispatch("getCmdLine", this.currentRowSelected.id)
        .then(() => {
          this.formParamsOpen = true;
        });
    },
    closeDialog() {
      this.formParamsOpen = false;
    },
    deleteClick() {
      this.$confirm(
        `${this.$t("configTasks.deleteWarning")}: ${
          this.currentRowSelected.caption
        }`,
        this.$t("configTasks.attention"),
        {
          confirmButtonText: "OK",
          cancelButtonText: this.$t("configTasks.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$store.commit("setLoading", true);
          return this.$store.dispatch("delTaskTable", this.currentId);
        })
        .then(() => {
          return this.$store.dispatch("getTasksTable");
        })
        .then(() => {
          this.$message(this.$t("configTasks.taskDeleted"));
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    addOk(value) {
      this.formOpen = false;
      this.$store.commit("setLoading", true);
      //console.log("value", value);
      this.$store
        .dispatch("createTask", value)
        .then(() => {
          return this.$store.dispatch("getTasksTable");
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    editOk(value) {
      this.formOpen = false;
      this.$store.commit("setLoading", true);
      //console.log(value);
      value.unshift(this.currentId);
      this.$store
        .dispatch("updTable", {
          updFn: "updTaskTable",
          updArray: value,
        })
        .then(() => {
          return this.$store.dispatch("getTasksTable");
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    updParams(paramsArray) {
      this.formParamsOpen = false;
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("updTaskParams", { idTask: this.currentId, paramsArray })
        .then(() => {
          this.$message(this.$t("configTasks.paramsEdited"));
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    optimalViewBtn() {
      this.gridApi.sizeColumnsToFit();
      this.settings.grids.packs.viewFull = false;
    },
    fullViewBtn() {
      let allColumnIds = [];
      this.columnApi
        .getAllColumns()
        .forEach((column) => allColumnIds.push(column.colId));
      this.columnApi.autoSizeColumns(allColumnIds);
      this.settings.grids.packs.viewFull = true;
    },
    backupBase() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("backupBase")
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    exportTask(action) {
      if (this.selectedArray.length === 0) {
        this.$store.commit("setError", this.$t("configTasks.noTasksError"));
        return;
      }
      this.$store.commit("setLoading", true);
      let result = [];
      if (this.selectedArray.length === this.getTasksTable.length) {
        result = "all";
      } else
        this.selectedArray.forEach((row) => {
          result.push(+row.id);
        });
      this.$store
        .dispatch("taskExport", { idArray: result, action })
        .then((result) => {
          const filename = action + "_task.json";
          const href = "data:application/text," + encodeURIComponent(result);
          const link = document.createElement("a");
          link.setAttribute("href", href);
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.$store.commit("setLoading", false);
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("setLoading", false);
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.setEnableCellTextSelection(true);
    },
    onGridSizeChanged(params) {
      params.api.sizeColumnsToFit();
      // this.autoSizeAll();
    },
    onGridDataChanged() {
      if (this.firstRenderFlag) this.$store.commit("setLoading", false);
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    onGridFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
      this.$store.commit("setLoading", false);
      this.firstRenderFlag = true;
    },
    onRowSelected(params) {
      //console.log(params);
      if (params.node.selected) {
        this.currentRowSelected = params.node.data; // текущая выбранная строка грида запоминается в буфере
        this.currentId = Object.values(this.currentRowSelected)[0];
        //console.log("CURRENT ROW: ", this.currentRowSelected);
        this.buttonDisabled = false;
        this.exportDisabled = false;
      }
      if (this.gridApi) {
        this.selectedArray = [...this.gridApi.getSelectedRows()];
        if (this.selectedArray.length > 1) {
          this.buttonDisabled = true;
        }
      }
    },
  },
  beforeMount() {
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }
    this.columnDefs = [
      {
        headerName: i18n.t("tableHeaders.task.id"),
        field: "id",
        comparator: (value1, value2) => parseInt(value1) - parseInt(value2),
        cellClass: "center-column",
      },
      { headerName: i18n.t("tableHeaders.task.caption"), field: "caption" },
      { headerName: i18n.t("tableHeaders.task.path"), field: "path" },
      {
        headerName: i18n.t("tableHeaders.task.isPacketable"),
        field: "isPacketable",
        cellClass: "center-column",
        valueGetter: (params) =>
          params.data.isPacketable === "1"
            ? this.$t("configTasks.yes")
            : this.$t("configTasks.no"),
      },
      {
        headerName: i18n.t("tableHeaders.task.idTypeTask"),
        field: "idTypeTask",
        valueGetter: (params) =>
          this.getTypeTaskTable.find(
            (type) => type.id === params.data.idTypeTask
          ).name,
      },
      { headerName: i18n.t("tableHeaders.task.comment"), field: "comment" },
    ];
    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      autoHeight: true,
    };
    this.settings = {
      grids: {
        packs: {
          viewFull: false,
        },
      },
    };
  },
  created() {
    Promise.all([
      this.$store.dispatch("getTasksTable"),
      this.$store.dispatch("getParamsTable"),
      this.$store.dispatch("getTypeTaskTable"),
    ]).then(() => {
      this.gridLoading = false;
      if (this.getTasksTable.length === 0) {
        this.$store.commit("setLoading", false);
      }
      //console.log("gridLoading = false");
    });
  },
  components: {
    AgGridVue,
    ConfigTaskForm,
    myHeader: Header,
    myForm: Form,
  },
  computed: {
    ...mapGetters(["getTasksTable", "getTypeTaskTable", "getUser"]),
  },
};
</script>

<style scoped>
</style>